module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAYAAAB4d5a9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgB7ZTBDcMgDEWNVe4ZoSNkhA7ADk0m6AoZoSN0A3qAcztKNmgWAPpDmp4TyVwinoSAi5+MjRUBa22jte5SSg0JgnhjCOF5mi8QvLC1SimSZI7HzFf+3Vsqx2WVvKkQyObxfx/vfRdjPJMgEEzGmDtV9pBrgnrc0NMDjqL/BIxYQ5Y45z4FBCsTU3kWCVq3pyU1cQHK0FNlD7m76qjfyIFG/RdYDEXM0QVyfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home.png
// module id = gAJj
// module chunks = 1